import React, { Component } from 'react'
import { CSSTransition } from "react-transition-group"
import { changeAuth, logout } from '../../actions/auth'
// import { withRouter } from 'react-router-dom';
import { REST_API } from '../../actions/constants'
import { connect } from 'react-redux';
import { Link, Switch, Route } from "react-router-dom";


class ChangePassword extends Component {


  state = {
    gotErrors: false,       // Will trigger the error message to display if TRUE
    success: false,         // Will trigger the Success message to display if TRUE
    errorMsg: '',           // Dynamic message depending on what type of error
    successMsg: '',         // The success message if everything is A OK
    curretPassError: false  // Will trigger to TRUE if the return object of changePassword() has an error OR invalid current password 
  }

  AbortController = new window.AbortController()


  componentWillUnmount() {
    this.AbortController.abort()
  }

  breadCrumb() {
    let breadCrumb = window.location.href.split("/");
    return breadCrumb;
  }

  /** 
   * Using KEY interpolation to dynamically set any input 
   * name added in the form into the component state
  */
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  /**
   * @arg   {Object}  post      : JSON object of the form values submitted
   * @param {string}  REST_API  : The API endpoint
   */
  changePassword = async (post) => {

    const userAcc = {
      realm: this.props.auth.user.realm,
      username: this.props.auth.user.username,
      email: this.props.auth.user.email,
      emailVerified: true,
      id: this.props.auth.user.id
    }


    const token = this.props.auth.access_token
    await fetch(`${REST_API}/users/change-password?access_token=${token}`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },

      body: JSON.stringify(post)
      // signal: this.AbortController.singal

    })
      .then(res => {
        // Error : supplied incorrect current password
        if (!res.ok) {
          this.setState({
            errorMsg: 'Current Password is incorrect',
            gotErrors: true,
            curretPassError: true
          })
        } else {
          // Success 
          this.setState({
            successMsg: `Password changed successfully, logging out from the app in a couple seconds`,
            success: true
          })

          // Set to logout from current session after 4 secs
          setTimeout(() => {

            this.props.dispatch(logout(this.props.auth.access_token))

            // Redirect to home page ( '/' ) 1 sec right after loggin out
            setTimeout(() => {
              this.props.history.push('/')
              setTimeout(() => {
                window.location.reload()
              }, 500)
            }, 1000)


          }, 4000)
        }


        fetch(`${REST_API}/users/?access_token=${token}`, {
          method: 'PATCH',
          headers: {
            'content-type': 'application/json'
          },

          body: JSON.stringify(userAcc)
          // signal: this.AbortController.singal

        })


      })
      // Catch the ERR object
      .catch((err) => console.log(err)) // Disable during production

  }


  // handle the form submission validation
  onSubmit = (e) => {
    e.preventDefault()

    const { newPassword, confirmNewPassword, currentPassword } = this.state

    const post = {
      // API requirement keys
      oldPassword: this.state.currentPassword,
      newPassword: this.state.newPassword,
    }

    if (newPassword && confirmNewPassword) {
      if (newPassword === confirmNewPassword && newPassword != currentPassword) {
        // Send POST request for password change
        this.changePassword(post)

      } else if (newPassword === confirmNewPassword && newPassword == currentPassword) {
        this.setState({
          errorMsg: 'New Password should be different from Old Password',
          gotErrors: true,
          newPassError: true
        })

      } else {
        // Display flash error that password does not match
        this.setState({
          errorMsg: 'Passwords does not match',
          gotErrors: true,
          newPassError: true
        })
      }
    } else {
      // display flash error that fields should not be empty
      this.setState({
        errorMsg: 'All fields must not be empty',
        gotErrors: true
      })

    }
  }

  /**
   *  Render the error message for 3 seconds
   *  then remove it right after the timer ends
   */
  renderMessage = () => {
    if (this.state.gotErrors) {
      setTimeout(() => {
        this.setState({
          gotErrors: false,
          curretPassError: false,
          newPassError: false
        })
      }, 3000)

      return this.state.errorMsg

    }

    if (this.state.success) {
      setTimeout(() => {
        this.setState({
          success: false,
          curretPassError: false,
          newPassError: false
        })
      }, 3000)

      return this.state.successMsg
    }

  }

  /** 
   * Validate if the response object of "CHANGE_PASSWORD" is correct
   * otherwise apply error indicator in the input field
   * 
   * */
  validateCurrentPassword = () => {
    return this.state.gotErrors && this.state.curretPassError ? 'is-invalid' : ''
  }

  validateNewPassword = () => {
    return this.state.gotErrors && this.state.newPassError ? 'is-invalid' : ''
  }


  /**
   * @TODO Complete this function to sanitize potentially dangerous strings
   * @DangerousStrings '<', '>', '/', '"', '\'', '(', ')', ':', ';'
   */

  // sanitizePotentialXSSstring = (string) => {
  //   const dangerousStrings = [
  //     '<', '>', '/', '"', '\'', '(', ')', ':', ';'
  //   ]
  //   return string.replace(dangerousStrings, '')
  // }

  /** ====================================================================== */


  render() {

    return (

      <CSSTransition
        in={true}
        appear={true}
        timeout={5000}
        classNames="fade"
      >
        <React.Fragment>
        <div className="working-area-content">
          <div className="component-title list-group" id="working-area">
            <div className="list-group-item list-group-item-action gradient-background">
              <div className="" id="endpoint-label-wrapper">
                <div className="float-left breadcrumbs">
                  <div className="">
                    <p>
                      <Link to={"/"}>
                        <i className="fas fa-th"></i>
                      </Link>
                      <i className="fas fa-arrow-right"></i>
                      <Link to={`/${this.breadCrumb()[3]}`}>
                        Change Password
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          <div className="change-password-form-wrapper">

            <form action="/" onSubmit={this.onSubmit}>
              <div className="form-group">
                <label htmlFor="new-password">Type current password</label>
                <input
                  type="password"
                  onChange={this.onChange}
                  name="currentPassword"
                  className={`form-control ${this.validateCurrentPassword()}`}
                  autoComplete="off"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="new-password">Type new password</label>
                <input
                  type="password"
                  onChange={this.onChange}
                  name="newPassword"
                  className={`form-control ${this.validateNewPassword()}`}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirm-new-password">Confirm new password</label>
                <input
                  type="password"
                  onChange={this.onChange}
                  name="confirmNewPassword"
                  className={`form-control ${this.validateNewPassword()}`}
                  autoComplete="off"
                  required
                />
              </div>
              <div className="form-group">
                <button
                  type="submit"
                  onChange={this.onChange}
                  value="Change Password"
                  name="confirmNewPassword"
                  className="btn btn-primary btn-block"
                  autoComplete="off"
                >Change Password</button>
              </div>


            </form>


          </div>
          <div className="text-center">
            <h4>
              <span className={`text-${this.state.gotErrors ? 'danger' : this.state.success ? 'success' : ''}`}>
                {this.renderMessage()}
              </span>
            </h4>
          </div>
        </div>
        </div>
        </React.Fragment>
      </CSSTransition>

    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth
  }
}


const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)





// WEBPACK FOOTER //
// ./src/components/changepassword/ChangePassword.js